import { render, staticRenderFns } from "./packaging_search.vue?vue&type=template&id=843b52cc&scoped=true&"
import script from "./packaging_search.vue?vue&type=script&lang=js&"
export * from "./packaging_search.vue?vue&type=script&lang=js&"
import style0 from "./packaging_search.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./packaging_search.vue?vue&type=style&index=1&id=843b52cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843b52cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('843b52cc')) {
      api.createRecord('843b52cc', component.options)
    } else {
      api.reload('843b52cc', component.options)
    }
    module.hot.accept("./packaging_search.vue?vue&type=template&id=843b52cc&scoped=true&", function () {
      api.rerender('843b52cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/packaging_search.vue"
export default component.exports